import type { HistoryOrder } from '@webapp/account/src/resources/my-orders/history-order';
import type { License } from '@webapp/account/src/resources/my-orders/license';

export interface Order {
    id: number;
    payPeriod: string;
    name: string;
    sum: number;
    amount: number;
}

export interface OrdersState {
    histories: Array<HistoryOrder>;
    licenses: Array<License>;
    orders: Array<Order>;
    fetch: boolean;
    invoiceId: number;
}

export const initialState: Readonly<OrdersState> = {
    histories: [],
    licenses: [],
    orders: [],
    fetch: false,
    invoiceId: 0,
};
